import React from 'react';
import { Section } from './FormFields';

const VISIBILITY_SECTIONS = [
  { key: 'hero', label: 'Hero Section' },
  { key: 'introVideo', label: 'Intro Video Section' },
  { key: 'aboutTeaser', label: 'About Teaser' },
  { key: 'missionTeaser', label: 'Mission Teaser' },
  { key: 'storyTeaser', label: 'Story Teaser' },
  { key: 'visionMissionValues', label: 'Vision, Mission & Values' },
  { key: 'whatWeOffer', label: 'What We Offer' },
  { key: 'whyChooseUs', label: 'Why Choose Us' },
  { key: 'freeTrialClass', label: 'Free Trial Class' },
  { key: 'testimonials', label: 'Testimonials' },
  { key: 'howItWorks', label: 'How It Works' },
  { key: 'faq', label: 'FAQ' },
  { key: 'finalCta', label: 'Final CTA' },
  { key: 'teamPage', label: 'Team Page' },
  { key: 'footer', label: 'Footer' }
];

const VisibilityTab = ({ content, updateSimpleField }) => {
  return (
    <Section title="Section Visibility" description="Toggle sections on/off across the website.">
      <div className="space-y-3">
        {VISIBILITY_SECTIONS.map(section => (
          <div key={section.key} className="flex items-center justify-between p-4 bg-white rounded-lg border border-slate-200">
            <span className="font-medium text-slate-900">{section.label}</span>
            <button 
              onClick={() => updateSimpleField(section.key, 'visible', !content[section.key]?.visible)}
              className={`relative w-12 h-7 rounded-full transition-colors ${content[section.key]?.visible !== false ? 'bg-green-500' : 'bg-slate-300'}`}
            >
              <span className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow transition-transform ${content[section.key]?.visible !== false ? 'left-6' : 'left-1'}`} />
            </button>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default VisibilityTab;
